<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-show="showMain" class="row-space">
        <div v-if="lsDados.length>0">
            <div class="table-wrapper row-space">
                <table>
                    <thead>
                        <tr>
                            <th>Referência</th>
                            <th>Protocolo</th>
                            <th>Data/Hora Solicitação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in lsDados" :key="item.id" @click="onClickItem(item)"
                        :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                            <td>{{ item.ref_titulo }}</td>
                            <td class="col-width-char40">{{ item.ref_protocolo }}</td>
                            <td class="col-width-char30 center">{{ Funcoes.formatDateTimeFromJson(item.dhpendencia) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>

            <div class="row-end">
                <button class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>


        <div v-else>
            <EmptyStateComponent 
                :title="'Protocolar Assinaturas'"
                :message="'No momento não existe nenhuma requisição de assinatura pendente para o seu usuário!'"
                :button-text="'Voltar'"
                @action="closeForm"
            />
        </div>
    </div>


    <template v-if="showDocAssinatura">
        <DocViewPage :idView="idView" :idAssinatura="idAssinatura" @close="showDocAssinatura = false; showMain = true" @save="lerDados" />
    </template>


    <template v-if="showRacAssinatura">
        <RacAssinaturaPage :idRac="idView" :idAssinatura="idAssinatura" @close="showRacAssinatura = false; showMain = true" @save="lerDados" />
    </template>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DocViewPage from '@/views/docs/visualizacoes/DocViewPage.vue';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';
import RacAssinaturaPage from '../outros/RacAssinaturaPage.vue';

const emit = defineEmits(['close']);

const idAssinatura = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);

const showMain = ref(true);
const showDocAssinatura = ref(false);
const showRacAssinatura = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/dados/assinatura/pendencia', {
            idep: globalStore.idep,
            idusuario: globalStore.idusuario,
            intparam1: 1,
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onClickItem(obj){
    idAssinatura.value = obj.id;
    idView.value = obj.ref_id;
    showMain.value = false;
    showDocAssinatura.value = obj.ref_tabela === 'DOC';
    showRacAssinatura.value = obj.ref_tabela === 'RAC';
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>